import { render, staticRenderFns } from "./FarmaciaPreferita.vue?vue&type=template&id=a35c4e2a&"
import script from "./FarmaciaPreferita.vue?vue&type=script&lang=js&"
export * from "./FarmaciaPreferita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports